/* OhMySmile theme JS — réplique des interactions du site Lovable */
(function () {
  'use strict';

  /* ---------- Scroll d'ancres fiable (RAF, insensible aux animations) ---------- */
  document.documentElement.style.scrollBehavior = 'auto';
  function smoothScrollTo(targetY) {
    var startY = window.scrollY;
    var diff = targetY - startY;
    var dur = Math.min(900, Math.max(350, Math.abs(diff) * 0.35));
    var start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var ease = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
      window.scrollTo(0, startY + diff * ease);
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  function scrollToHash(hash) {
    var id = hash.replace(/^#/, '');
    var el = document.getElementById(id);
    if (!el) return false;
    var y = el.getBoundingClientRect().top + window.scrollY - 70; /* offset nav sticky */
    window.scrollTo(0, y); /* saut direct fiable */
    if (document.visibilityState === 'visible') smoothScrollTo(y); /* lissage si possible */
    return true;
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="#"]');
    if (!a) return;
    var href = a.getAttribute('href');
    var hashIndex = href.indexOf('#');
    if (hashIndex === -1) return;
    var path = href.slice(0, hashIndex);
    var samePage = path === '' || path === location.pathname || (path === '/' && location.pathname === '/');
    if (!samePage) return;
    if (scrollToHash(href.slice(hashIndex))) {
      e.preventDefault();
      history.pushState(null, '', href.slice(hashIndex));
    }
  });
  if (location.hash) {
    setTimeout(function () { scrollToHash(location.hash); }, 150);
  }

  /* ---------- Menu mobile ---------- */
  var menuBtn = document.querySelector('[data-oms-menu-btn]');
  var menuPanel = document.querySelector('[data-oms-menu]');
  if (menuBtn && menuPanel) {
    menuBtn.addEventListener('click', function () {
      menuPanel.classList.toggle('open');
    });
    menuPanel.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { menuPanel.classList.remove('open'); });
    });
  }

  /* ---------- Accordéons ---------- */
  document.querySelectorAll('[data-oms-accordion]').forEach(function (group) {
    var items = group.querySelectorAll('[data-oms-acc-item]');
    items.forEach(function (item) {
      var btn = item.querySelector('[data-oms-acc-btn]');
      var content = item.querySelector('[data-oms-acc-content]');
      if (!btn || !content) return;
      btn.addEventListener('click', function () {
        var isOpen = item.getAttribute('data-state') === 'open';
        items.forEach(function (other) {
          other.setAttribute('data-state', 'closed');
          var b = other.querySelector('[data-oms-acc-btn]');
          var c = other.querySelector('[data-oms-acc-content]');
          if (b) { b.setAttribute('data-state', 'closed'); b.setAttribute('aria-expanded', 'false'); }
          if (c) { c.hidden = true; }
        });
        if (!isOpen) {
          item.setAttribute('data-state', 'open');
          btn.setAttribute('data-state', 'open');
          btn.setAttribute('aria-expanded', 'true');
          content.hidden = false;
        }
      });
    });
  });

  /* ---------- Galerie produit (desktop) ---------- */
  var mainImg = document.querySelector('[data-oms-main-img]');
  document.querySelectorAll('[data-oms-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (!mainImg) return;
      var img = thumb.querySelector('img');
      mainImg.src = img.src;
      document.querySelectorAll('[data-oms-thumb]').forEach(function (t) {
        t.classList.remove('border-accent', 'shadow-card');
        t.classList.add('border-border', 'opacity-60');
      });
      thumb.classList.add('border-accent', 'shadow-card');
      thumb.classList.remove('border-border', 'opacity-60');
    });
  });

  /* ---------- Galerie mobile : dots ---------- */
  var mScroll = document.querySelector('[data-oms-mgallery]');
  var dots = document.querySelectorAll('[data-oms-dot]');
  if (mScroll && dots.length) {
    mScroll.addEventListener('scroll', function () {
      var idx = Math.round(mScroll.scrollLeft / mScroll.clientWidth);
      dots.forEach(function (d, i) {
        d.className = 'h-2 rounded-full transition-all ' + (i === idx ? 'w-5 bg-accent' : 'w-2 bg-muted-foreground/30');
      });
    }, { passive: true });
  }

  /* ---------- Packs / variantes ---------- */
  var PACKS = window.OMS_PACKS || [];
  var current = 1; /* Duo by default */
  var atcBtn = document.querySelector('[data-oms-atc]');
  var atcLabel = document.querySelector('[data-oms-atc-label]');

  function selectPack(i) {
    current = i;
    document.querySelectorAll('[data-oms-pack]').forEach(function (card, j) {
      card.classList.remove('border-[#7B4FD4]', 'bg-[#F5F0FF]', 'border-border', 'bg-[#F8F8F8]', 'bg-card');
      if (j === i) {
        card.classList.add('border-[#7B4FD4]', 'bg-[#F5F0FF]');
      } else {
        card.classList.add('border-border', j === 0 ? 'bg-[#F8F8F8]' : 'bg-card');
      }
    });
    if (atcLabel && PACKS[i]) atcLabel.textContent = '🛒 ADD TO CART · ' + PACKS[i].price;
  }
  document.querySelectorAll('[data-oms-pack]').forEach(function (card, i) {
    card.addEventListener('click', function () { selectPack(i); });
  });

  /* ---------- Teinte ---------- */
  var TEINTES = [
    { label: 'A1', reco: 0, txt: 'Perfect to maintain your natural whiteness.' },
    { label: 'A2', reco: 1, txt: 'Recommended to revive your shine in 14 days.' },
    { label: 'A3', reco: 1, txt: 'Recommended to neutralize yellow in 14 days.' },
    { label: 'B1', reco: 2, txt: 'Recommended for maximum results in 30 days.' },
    { label: 'B2', reco: 2, txt: 'Recommended for maximum results in 30 days.' }
  ];
  var range = document.querySelector('[data-oms-range]');
  var recoName = document.querySelector('[data-oms-reco-name]');
  var recoPrice = document.querySelector('[data-oms-reco-price]');
  var recoTxt = document.querySelector('[data-oms-reco-txt]');

  function selectTeinte(i) {
    document.querySelectorAll('[data-oms-teinte]').forEach(function (b, j) {
      var dot = b.querySelector('span:first-child');
      var lab = b.querySelector('span:last-child');
      if (j === i) {
        b.classList.add('scale-105'); b.classList.remove('opacity-60');
        dot.classList.add('border-accent', 'shadow-md'); dot.classList.remove('border-border');
        lab.classList.add('text-accent'); lab.classList.remove('text-muted-foreground');
      } else {
        b.classList.remove('scale-105'); b.classList.add('opacity-60');
        dot.classList.remove('border-accent', 'shadow-md'); dot.classList.add('border-border');
        lab.classList.remove('text-accent'); lab.classList.add('text-muted-foreground');
      }
    });
    if (range) range.value = i;
    var t = TEINTES[i]; var p = PACKS[t.reco];
    if (recoName && p) recoName.textContent = p.name;
    if (recoPrice && p) recoPrice.innerHTML = p.price + (p.compare ? '<span class="text-[11px] md:text-xs text-muted-foreground line-through ml-1.5 font-normal">' + p.compare + '</span>' : '');
    if (recoTxt) recoTxt.textContent = t.txt;
    var seeBtn = document.querySelector('[data-oms-reco-see]');
    if (seeBtn) seeBtn.onclick = function () { selectPack(t.reco); };
  }
  document.querySelectorAll('[data-oms-teinte]').forEach(function (b, i) {
    b.addEventListener('click', function () { selectTeinte(i); });
  });
  if (range) range.addEventListener('input', function () { selectTeinte(parseInt(range.value, 10)); });

  /* ---------- Cart drawer ---------- */
  var META = window.OMS_CART_META || { threshold: 4990, variants: {} };
  var drawer = document.querySelector('[data-oms-cart-drawer]');
  var overlay = document.querySelector('[data-oms-cart-overlay]');
  var itemsBox = document.querySelector('[data-oms-cart-items]');
  var shipMsg = document.querySelector('[data-oms-ship-msg]');
  var shipBar = document.querySelector('[data-oms-ship-bar]');
  var totalEl = document.querySelector('[data-oms-cart-total]');
  var compareEl = document.querySelector('[data-oms-cart-compare]');
  var countBadge = document.querySelector('[data-oms-cart-count]');

  function euros(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('open');
    overlay.classList.add('open');
    document.body.classList.add('oms-cart-open');
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open');
    overlay.classList.remove('open');
    document.body.classList.remove('oms-cart-open');
  }
  if (overlay) overlay.addEventListener('click', closeDrawer);
  var closeBtn = document.querySelector('[data-oms-cart-close]');
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  function renderCart(cart) {
    if (!itemsBox) return;
    if (countBadge) {
      countBadge.textContent = cart.item_count;
      countBadge.classList.toggle('hidden', cart.item_count === 0);
      countBadge.classList.toggle('flex', cart.item_count > 0);
    }
    /* Barre livraison offerte */
    var pct = Math.min(100, Math.round((cart.total_price / META.threshold) * 100));
    if (shipBar) shipBar.style.width = pct + '%';
    if (shipMsg) {
      if (cart.item_count === 0) {
        shipMsg.textContent = 'Free shipping over $49.90';
        shipMsg.style.color = 'rgb(123, 79, 212)';
      } else if (cart.total_price >= META.threshold) {
        shipMsg.textContent = '✅ Free shipping unlocked!';
        shipMsg.style.color = 'rgb(34, 197, 94)';
      } else {
        shipMsg.textContent = 'Only ' + euros(META.threshold - cart.total_price) + ' away from free shipping 🚚';
        shipMsg.style.color = 'rgb(123, 79, 212)';
      }
    }
    /* Lignes */
    if (cart.item_count === 0) {
      itemsBox.innerHTML = '<p class="text-sm text-center px-5 py-10" style="color: rgb(136, 136, 136);">Your cart is empty.</p>';
    } else {
      itemsBox.innerHTML = cart.items.map(function (item) {
        var meta = META.variants[String(item.variant_id)] || {};
        var title = meta.title || item.product_title;
        var sub = meta.sub || item.variant_title || '';
        var compareHtml = meta.compare ? '<span class="text-[13px] line-through" style="color: rgb(187, 187, 187);">' + meta.compare + '</span>' : '';
        var pctHtml = meta.pct ? '<span class="text-[10px] font-bold px-1.5 py-0.5 rounded-full" style="background-color: rgb(240, 235, 255); color: rgb(123, 79, 212);">' + meta.pct + '</span>' : '';
        return '<div class="flex items-start gap-3 px-5 py-4" style="border-bottom: 1px solid rgb(240, 235, 255);">' +
          '<img src="' + item.image + '" alt="" class="w-20 h-20 rounded-lg object-cover shrink-0">' +
          '<div class="flex-1 min-w-0">' +
          '<p class="text-sm font-medium truncate" style="color: rgb(26, 26, 26);">' + title + '</p>' +
          '<p class="text-xs mt-0.5" style="color: rgb(136, 136, 136);">' + sub + '</p>' +
          '<div class="flex items-center gap-2 mt-1.5">' + compareHtml +
          '<span class="text-base font-bold" style="color: rgb(123, 79, 212);">' + euros(item.final_line_price) + '</span>' + pctHtml + '</div>' +
          '<div class="flex items-center justify-between mt-2">' +
          '<div class="flex items-center gap-1.5">' +
          '<button data-oms-qty="' + item.key + '|' + (item.quantity - 1) + '" class="w-7 h-7 rounded-full flex items-center justify-center transition-colors disabled:opacity-50" style="border: 1px solid rgb(232, 222, 255);"><svg class="h-3 w-3"><use href="#ic-minus"/></svg></button>' +
          '<span class="text-sm font-medium w-6 text-center">' + item.quantity + '</span>' +
          '<button data-oms-qty="' + item.key + '|' + (item.quantity + 1) + '" class="w-7 h-7 rounded-full flex items-center justify-center transition-colors disabled:opacity-50" style="border: 1px solid rgb(232, 222, 255);"><svg class="h-3 w-3"><use href="#ic-plus"/></svg></button>' +
          '</div>' +
          '<button data-oms-qty="' + item.key + '|0" class="text-[11px] transition-colors disabled:opacity-50" style="color: rgb(239, 68, 68);">Remove</button>' +
          '</div></div></div>';
      }).join('');
      /* Cadeau racleur de langue (Trio) */
      if (META.gift && cart.items.some(function (i) { return String(i.variant_id) === String(META.gift.trio); })) {
        itemsBox.innerHTML += '<div class="flex items-start gap-3 px-5 py-4" style="border-bottom: 1px solid rgb(240, 235, 255); background-color: rgb(247, 243, 255);">' +
          '<div class="w-20 h-20 rounded-lg shrink-0 flex items-center justify-center text-3xl" style="background-color: rgb(240, 235, 255);">\uD83C\uDF81</div>' +
          '<div class="flex-1 min-w-0">' +
          '<p class="text-sm font-medium" style="color: rgb(26, 26, 26);">' + META.gift.title + '</p>' +
          '<p class="text-xs mt-0.5" style="color: rgb(136, 136, 136);">' + META.gift.sub + '</p>' +
          '<div class="flex items-center gap-2 mt-1.5">' +
          '<span class="text-[13px] line-through" style="color: rgb(187, 187, 187);">' + META.gift.value + '</span>' +
          '<span class="text-[11px] font-bold px-2 py-0.5 rounded-full" style="background-color: rgb(220, 252, 231); color: rgb(22, 163, 74);">' + META.gift.badge + '</span>' +
          '</div></div></div>';
      }
      itemsBox.querySelectorAll('[data-oms-qty]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var parts = btn.getAttribute('data-oms-qty').split('|');
          btn.disabled = true;
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: parts[0], quantity: Math.max(0, parseInt(parts[1], 10)) })
          }).then(function (r) { return r.json(); }).then(renderCart).catch(function () { btn.disabled = false; });
        });
      });
    }
    /* Total */
    if (totalEl) totalEl.textContent = euros(cart.total_price);
    if (compareEl) {
      var compareTotal = cart.items.reduce(function (acc, item) {
        var meta = META.variants[String(item.variant_id)] || {};
        if (meta.compare) {
          var c = parseFloat(meta.compare.replace(',', '.')) * 100;
          return acc + c * item.quantity;
        }
        return acc + item.final_line_price;
      }, 0);
      compareEl.textContent = (compareTotal > cart.total_price) ? euros(compareTotal) : '';
    }
  }

  function refreshCart(open) {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      renderCart(cart);
      if (open) openDrawer();
    });
  }
  refreshCart(false);

  var checkoutBtn = document.querySelector('[data-oms-checkout]');
  if (checkoutBtn) checkoutBtn.addEventListener('click', function () { window.location.href = '/checkout'; });

  document.querySelectorAll('[data-oms-open-cart]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); refreshCart(true); });
  });

  /* ---------- Add to cart ---------- */
  if (atcBtn) {
    atcBtn.addEventListener('click', function () {
      var p = PACKS[current];
      if (!p) return;
      atcBtn.disabled = true;
      if (atcLabel) atcLabel.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: p.variant, quantity: 1 })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        atcBtn.disabled = false;
        if (atcLabel) atcLabel.textContent = '🛒 ADD TO CART · ' + p.price;
        refreshCart(true);
      }).catch(function () {
        atcBtn.disabled = false;
        if (atcLabel) atcLabel.textContent = '🛒 ADD TO CART · ' + p.price;
      });
    });
  }

  /* ---------- Rotateur de témoignages ---------- */
  var quotes = document.querySelectorAll('[data-oms-quote]');
  if (quotes.length > 1) {
    var qi = 0;
    setInterval(function () {
      qi = (qi + 1) % quotes.length;
      quotes.forEach(function (q, j) {
        if (j === qi) {
          q.style.position = 'relative'; q.style.pointerEvents = 'auto'; q.style.opacity = '1';
        } else {
          q.style.position = 'absolute'; q.style.pointerEvents = 'none'; q.style.opacity = '0';
          q.style.top = '0'; q.style.left = '0'; q.style.right = '0';
        }
      });
    }, 4200);
  }

  /* ---------- Compteurs animés ---------- */
  var counters = document.querySelectorAll('[data-oms-count]');
  if (counters.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var el = e.target;
        var target = parseInt(el.getAttribute('data-oms-count'), 10);
        var prefix = el.getAttribute('data-prefix') || '';
        var suffix = el.getAttribute('data-suffix') || '';
        var start = null;
        function step(ts) {
          if (!start) start = ts;
          var pr = Math.min((ts - start) / 1600, 1);
          var val = Math.round(target * (1 - Math.pow(1 - pr, 3)));
          el.textContent = prefix + val.toLocaleString('en-US').replace(/ /g, ' ') + suffix;
          if (pr < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });
    counters.forEach(function (c) { io.observe(c); });
  }

  /* ---------- Slider avant / après ---------- */
  var ba = document.querySelector('[data-oms-ba]');
  if (ba) {
    var beforeImg = ba.querySelector('[data-oms-ba-before]');
    var bar = ba.querySelector('[data-oms-ba-bar]');
    function setPos(clientX) {
      var rect = ba.getBoundingClientRect();
      var pct = Math.max(0, Math.min(100, ((clientX - rect.left) / rect.width) * 100));
      beforeImg.style.clipPath = 'inset(0px ' + (100 - pct) + '% 0px 0px)';
      bar.style.left = pct + '%';
    }
    var dragging = false;
    ba.addEventListener('pointerdown', function (e) { dragging = true; ba.setPointerCapture(e.pointerId); setPos(e.clientX); });
    ba.addEventListener('pointermove', function (e) { if (dragging) setPos(e.clientX); });
    ba.addEventListener('pointerup', function () { dragging = false; });
    ba.addEventListener('pointercancel', function () { dragging = false; });
  }
})();
